import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import HeroBgAnimation from '../HeroBgAnimation';
import { 
    HeroContainer, 
    HeroBg, 
    HeroTopContainer, 
    Img, 
    HeroBottomContainer, 
    HeroInnerContainer, 
    TextLoop, 
    Title, 
    Span, 
} from './HeroStyle';
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';

// Define the keyframes for the bounce animation
const bounceAnimation = keyframes`
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-6px);
    }
`;

// Styled component for FontAwesome icon with animation
const BouncingIcon = styled(FontAwesomeIcon)`
    animation: ${bounceAnimation} 2s infinite;
    cursor: pointer; /* Add cursor pointer for indicating clickable */
    margin-bottom:150px;
`;

const HeroSection = () => {
    // Function to handle scroll when clicking on the down arrow
    const handleScrollDown = () => {
        const element = document.getElementById('about'); // Replace with the ID of the section you want to scroll to
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer>
                    <HeroTopContainer id="Top">
                        <Img src='https://hemangnakarani.github.io/astro/ssa.DaGceUPd_Z2wtw7E.svg' alt="Bhavy Zala" loading='lazy'/>
                    </HeroTopContainer>

                    <HeroBottomContainer id="Bottom" style={{ marginTop: '55px', marginBottom: '50px' }}>
                        <Title>Hi, I am {Bio.name}</Title>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <BouncingIcon icon={faChevronDown} style={{ color: 'white' }} onClick={handleScrollDown} />
                    </HeroBottomContainer>
                </HeroInnerContainer>
            </HeroContainer>
        </div>
    );
};

export default HeroSection;
